import { error, finish } from '../../../modules/markets/actions/get-all-markets-by-event';
import api from '../../../api';

export function request(dispatch, { eventId }) {
    api.get(`/events/${eventId}/markets`).then(resp => {
        dispatch(finish(resp));
    }).catch(err => {
        dispatch(error(err));
    });
}
